(() => {
  if (window.__brRoyalPopModelGalleryRuntimeR44264) return;
  window.__brRoyalPopModelGalleryRuntimeR44264 = true;

  const COLLECTION_PATH = '/collections/royal-pop-cases';
  const ROYAL_BANDS_PATH = '/collections/royal-pop-bands';
  const PRODUCT_SELECTOR = '[data-royal-pop-pdp-model-selector]';
  const normalize = (value) => String(value || '').trim().toLowerCase();
  let activeCollectionSlug = null;

  const parseModels = (scope = document) => {
    const node = scope.querySelector?.('[data-royal-pop-model-data]') || document.querySelector('[data-royal-pop-model-data]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch (_) { return []; }
  };

  const explicitModelParam = () => new URL(window.location.href).searchParams.get('model');
  const rememberedModelSlug = () => {
    const remembered = window.BrilintonDeviceContext?.get?.('royalPop');
    return remembered?.modelSlug || remembered?.handle || '';
  };
  const modelContext = () => explicitModelParam() || rememberedModelSlug() || '';
  const findModel = (models, value) => {
    if (!value) return null;
    const numeric = Number.parseInt(value, 10);
    if (/^\d+$/.test(value) && models[numeric]) return models[numeric];
    return models.find((model) => normalize(model.slug) === normalize(value)) || null;
  };
  const isBase = (model) => normalize(model?.name) === 'ocho negro';
  const isThreeClock = (model) => /^3(?:\s|$|\s*o|\s*o’clock|\s*o'clock)/i.test(String(model?.crownPosition || '').trim()) || normalize(model?.crownPosition).includes('3 o');

  const parseJsonNode = (node) => {
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch (_) { return []; }
  };

  const rememberImageSource = (image) => {
    if (!image || image.dataset.royalPopOriginalRemembered === 'true') return;
    image.dataset.royalPopOriginalRemembered = 'true';
    image.dataset.royalPopOriginalSrc = image.getAttribute('src') || '';
    image.dataset.royalPopOriginalSrcset = image.getAttribute('srcset') || '';
    image.dataset.royalPopOriginalSizes = image.getAttribute('sizes') || '';
  };

  const setImageBase = (image, alternateUrl) => {
    if (!image) return;
    rememberImageSource(image);
    if (alternateUrl) {
      if (image.getAttribute('src') !== alternateUrl) image.setAttribute('src', alternateUrl);
      image.setAttribute('srcset', alternateUrl);
      image.removeAttribute('sizes');
      image.dataset.royalPopUsing3Clock = 'true';
    } else if (image.dataset.royalPopUsing3Clock === 'true') {
      image.setAttribute('src', image.dataset.royalPopOriginalSrc || '');
      if (image.dataset.royalPopOriginalSrcset) image.setAttribute('srcset', image.dataset.royalPopOriginalSrcset); else image.removeAttribute('srcset');
      if (image.dataset.royalPopOriginalSizes) image.setAttribute('sizes', image.dataset.royalPopOriginalSizes); else image.removeAttribute('sizes');
      delete image.dataset.royalPopUsing3Clock;
    }
  };

  const setUrlModel = (model) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('device');
    if (model?.slug) url.searchParams.set('model', model.slug);
    else url.searchParams.delete('model');
    history.pushState({ royalPopModel: model?.slug || null }, '', `${url.pathname}${url.search}${url.hash}`);
  };


  const isRoyalPopProductPath = (pathname) =>
    pathname.includes('/collections/royal-pop-cases/products/') ||
    pathname.includes('/collections/royal-pop-bands/products/') ||
    (/\/products\//.test(pathname) && (/royal-pop/i.test(pathname) || /bandware/i.test(pathname)));

  const syncRoyalPopLinks = (slug = modelContext()) => {
    document.querySelectorAll('a[href]').forEach((anchor) => {
      const raw = anchor.getAttribute('href');
      if (!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:') || raw.startsWith('javascript:')) return;
      let url;
      try { url = new URL(raw, window.location.origin); } catch (_) { return; }
      if (url.origin !== window.location.origin) return;

      const cleanPath = url.pathname.replace(/\/$/, '');
      const frameSection = anchor.closest('[data-royal-frame-section]');
      const relevant = isRoyalPopProductPath(url.pathname) || cleanPath === COLLECTION_PATH || cleanPath === ROYAL_BANDS_PATH || Boolean(frameSection);
      if (!relevant) return;

      url.searchParams.delete('device');
      if (slug) url.searchParams.set('model', slug);
      else url.searchParams.delete('model');
      if (frameSection && /\/products\//.test(url.pathname)) url.searchParams.set('set', 'complete');
      if (window.location.pathname.replace(/\/$/, '') === ROYAL_BANDS_PATH && /\/products\//.test(url.pathname)) {
        url.searchParams.set('wear', 'royal-pop');
        url.searchParams.set('set', 'complete');
      }
      anchor.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  };

  /* Collection: keep one overlay per native image. On mobile each overlay sits
     over its matching horizontal slide. On desktop the native slider fades images
     in place, so only the overlay matching data-current-slide is shown. */
  const syncCollectionOverlayState = (slider, explicitIndex) => {
    if (!slider) return;
    const isMobile = window.matchMedia?.('(max-width: 749px)').matches;
    const currentIndex = Number.isInteger(explicitIndex)
      ? Math.max(0, explicitIndex)
      : Math.max(0, Number.parseInt(slider.dataset.currentSlide || '1', 10) - 1);
    Array.from(slider.children || []).filter((node) => node?.classList?.contains('royal-pop-card-slide-overlay')).forEach((overlay) => {
      const index = Number.parseInt(overlay.dataset.slideIndex || '0', 10);
      overlay.classList.toggle('is-active', isMobile || index === currentIndex);
    });
  };

  const bindCollectionSlider = (slider) => {
    if (!slider || slider.dataset.royalPopOverlayBound === 'true') return;
    slider.dataset.royalPopOverlayBound = 'true';

    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'data-current-slide')) {
        syncCollectionOverlayState(slider);
      }
    }).observe(slider, { attributes: true, attributeFilter: ['data-current-slide'] });

    slider.addEventListener('click', () => requestAnimationFrame(() => syncCollectionOverlayState(slider)));
    slider.addEventListener('scroll', () => syncCollectionOverlayState(slider), { passive: true });
  };

  const syncCollectionLayer = (slider, gallery, model) => {
    if (!slider) return;
    const originalImages = Array.from(slider.children || []).filter((node) => node?.tagName === 'IMG');
    const twelveGallery = parseJsonNode(slider.parentElement?.querySelector('[data-royal-pop-card-12-gallery]'));
    const threeGallery = parseJsonNode(slider.parentElement?.querySelector('[data-royal-pop-card-3-gallery]'));
    const useThreeClock = isThreeClock(model) && threeGallery.length > 0;
    const contextualBaseGallery = useThreeClock ? threeGallery : twelveGallery;
    const hasContextualBase = Boolean(model && contextualBaseGallery.length);
    originalImages.forEach((image, index) => {
      const hasContextualImage = !hasContextualBase || Boolean(contextualBaseGallery[index]);
      image.hidden = !hasContextualImage;
      setImageBase(image, hasContextualBase && hasContextualImage ? contextualBaseGallery[index] : '');
    });
    const visibleImages = originalImages.filter((image) => !image.hidden);
    const existing = new Map(
      Array.from(slider.children || []).filter((node) => node?.classList?.contains('royal-pop-card-slide-overlay')).map((node) => [Number(node.dataset.slideIndex), node])
    );

    bindCollectionSlider(slider);

    if (!gallery.length || !visibleImages.length) {
      existing.forEach((node) => node.remove());
      slider.classList.remove('royal-pop-card-slider--composed');
      slider.dataset.slides = String(visibleImages.length || originalImages.length || 1);
      return;
    }

    slider.classList.add('royal-pop-card-slider--composed');
    slider.dataset.slides = String(visibleImages.length);
    visibleImages.forEach((image, index) => {
      const url = gallery[index] || '';
      let overlay = existing.get(index);
      if (!url) {
        overlay?.remove();
        existing.delete(index);
        return;
      }
      if (!overlay) {
        overlay = document.createElement('span');
        overlay.className = 'royal-pop-card-slide-overlay';
        overlay.dataset.slideIndex = String(index);
        overlay.setAttribute('aria-hidden', 'true');
        slider.appendChild(overlay);
      }
      overlay.style.setProperty('--royal-pop-slide-index', String(index));
      const nextBackground = `url("${String(url).replace(/"/g, '\\"')}")`;
      if (overlay.style.backgroundImage !== nextBackground) overlay.style.backgroundImage = nextBackground;
      existing.delete(index);
    });
    existing.forEach((node) => node.remove());
    syncCollectionOverlayState(slider);
  };

  const applyCollection = (slug) => {
    const currentCollection = window.location.pathname.replace(/\/$/, '');
    if (currentCollection !== COLLECTION_PATH && currentCollection !== ROYAL_BANDS_PATH) return;
    if (slug !== undefined) activeCollectionSlug = slug;
    if (activeCollectionSlug === null) activeCollectionSlug = modelContext();

    const models = parseModels();
    const model = findModel(models, activeCollectionSlug) || models.find(isBase) || models[0] || null;
    if (model && !activeCollectionSlug) activeCollectionSlug = model.slug || null;
    const isRoyalBandware = currentCollection === ROYAL_BANDS_PATH;
    const selectedGallery = isRoyalBandware ? model?.frameGallery : model?.gallery;
    const gallery = model && Array.isArray(selectedGallery)
      ? (isRoyalBandware || !isBase(model) ? selectedGallery.filter(Boolean) : [])
      : [];

    const selector = isRoyalBandware
      ? '.product-card-wrapper .card__media .card-product__slider[data-bandware-card-context="royal-pop"]'
      : '.product-card-wrapper .card__media .card-product__slider';
    document.querySelectorAll(selector).forEach((slider) => {
      if (slider.closest('[data-royal-frame-section]')) return;
      syncCollectionLayer(slider, gallery, model);
    });

    const frameGallery = model && Array.isArray(model.frameGallery) ? model.frameGallery : [];
    document.querySelectorAll('[data-royal-frame-section] .product-card-wrapper .card__media .card-product__slider').forEach((slider) => {
      syncCollectionLayer(slider, frameGallery, model);
    });
    syncRoyalPopLinks(model?.slug || activeCollectionSlug || null);
  };

  /* Homepage and other embedded Royal Pop rails use the exact same card
     composition method as the Royal Pop collection page. The scope owns only
     selection and link state; syncCollectionLayer owns all image/overlay work. */
  const syncScopedLinks = (root, slug) => {
    if (!root) return;
    root.querySelectorAll('a[href]').forEach((anchor) => {
      const base = anchor.dataset.royalPopBaseHref || anchor.dataset.baseHref || anchor.getAttribute('href');
      if (!base) return;
      if (!anchor.dataset.royalPopBaseHref) anchor.dataset.royalPopBaseHref = base;
      let url;
      try { url = new URL(anchor.dataset.royalPopBaseHref, window.location.origin); } catch (_) { return; }
      if (url.origin !== window.location.origin) return;
      const cleanPath = url.pathname.replace(/\/$/, '');
      const contextualCard = anchor.closest('[data-royal-pop-watchware-card="true"], [data-royal-pop-bandware-card="true"]');
      const relevant = isRoyalPopProductPath(url.pathname) || cleanPath === COLLECTION_PATH || cleanPath === ROYAL_BANDS_PATH || anchor.hasAttribute('data-model-link') || Boolean(contextualCard);
      if (!relevant) return;
      url.searchParams.delete('device');
      if (slug) url.searchParams.set('model', slug);
      else url.searchParams.delete('model');
      if (/\/products\//.test(url.pathname) && (/bandware/i.test(url.pathname) || anchor.closest('[data-rail-kind="bandware"]') || anchor.closest('[data-royal-pop-bandware-card="true"]'))) {
        url.searchParams.set('wear', 'royal-pop');
        url.searchParams.set('set', 'complete');
      }
      anchor.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  };

  const applyScopedCollection = (root, slug) => {
    if (!root) return;
    const models = parseModels(root);
    if (!models.length) return;
    const requested = slug || modelContext() || root.dataset.activeRoyalModel || root.dataset.defaultModel;
    const model = findModel(models, requested) || models.find(isBase) || models[0];
    if (!model) return;
    root.dataset.activeRoyalModel = model.slug || '';
    const watchwareGallery = !isBase(model) && Array.isArray(model.gallery) ? model.gallery.filter(Boolean) : [];
    const scopedSliderSelector = root.hasAttribute('data-royal-pop-recommendations-scope')
      ? '.product-card-wrapper[data-royal-pop-watchware-card="true"] .card__media .card-product__slider, .product-card-wrapper[data-royal-pop-bandware-card="true"] .card__media .card-product__slider'
      : '.product-card-wrapper .card__media .card-product__slider';
    root.querySelectorAll(scopedSliderSelector).forEach((slider) => {
      const bandwareCard = slider.closest('[data-royal-pop-bandware-card="true"]');
      const overlayGallery = bandwareCard && Array.isArray(model.frameGallery)
        ? model.frameGallery.filter(Boolean)
        : watchwareGallery;
      syncCollectionLayer(slider, overlayGallery, model);
    });
    root.querySelectorAll('[data-royal-pop-model-choice]').forEach((choice) => {
      const selected = normalize(choice.dataset.modelSlug) === normalize(model.slug);
      choice.classList.toggle('is-selected', selected);
      choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    syncScopedLinks(root, model.slug || null);
  };

  const clearScopedCollection = (root) => {
    if (!root) return;
    root.querySelectorAll('.product-card-wrapper[data-royal-pop-watchware-card="true"] .card__media .card-product__slider, .product-card-wrapper[data-royal-pop-bandware-card="true"] .card__media .card-product__slider').forEach((slider) => {
      syncCollectionLayer(slider, [], null);
    });
  };

  const recommendationFlickity = (list) => (
    list && typeof window.Flickity?.data === 'function' ? window.Flickity.data(list) : null
  );

  const initializeRecommendationFlickity = (list) => {
    if (!list || list.classList.contains('flickity-enabled') || typeof window.Flickity !== 'function') return null;
    return new window.Flickity(list, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: false,
      percentPosition: true,
      cellSelector: '.grid__item:not([hidden])',
    });
  };

  const syncRecommendationDeviceVisibility = (root, wear) => {
    if (!root) return;
    const list = root.querySelector('.related-products-slider');
    if (!list) return;

    /* R44-202 — Never tear down Flickity just because this synchronizer ran.
       R44-201 did exactly that, and the global card MutationObserver saw the
       destroy/rebuild DOM movement as a fresh recommendation change. That
       called this function again, which destroyed/rebuilt Flickity again, and
       created the continuous "freaking out" loop.

       Instead, calculate the desired membership against every candidate card
       (including hidden fallback cards that Flickity leaves outside its slider).
       Rebuild Flickity only when at least one card actually needs to enter or
       leave the visible recommendation set. Re-entrant observer passes with the
       same context become true no-ops. */
    const device = wear === 'royal-pop' || wear === 'apple-watch' ? wear : '';
    const maxVisible = Math.max(1, Number(root.dataset.productsToShow || 10));
    const items = Array.from(list.querySelectorAll('.grid__item'));
    const seenHandles = new Set();
    let visibleCount = 0;
    const desired = new Map();

    items.forEach((item) => {
      const source = item.dataset.relatedSource || 'recommendation';
      const handle = normalize(item.dataset.relatedProductHandle);
      const watchwareCard = item.querySelector('[data-watchware-card-device]');
      const cardDevice = normalize(watchwareCard?.dataset.watchwareCardDevice);
      const fallbackDevice = normalize(item.dataset.relatedFallbackDevice);

      // Native Shopify recommendations keep priority. Fallback collection cards only
      // participate after the shopper has an explicit Apple Watch / Royal Pop context.
      const sourceAllowed = source !== 'fallback' || Boolean(device && fallbackDevice === device);
      const deviceAllowed = !device || !cardDevice || cardDevice === device;
      const unique = !handle || !seenHandles.has(handle);
      const shouldShow = sourceAllowed && deviceAllowed && unique && visibleCount < maxVisible;

      if (shouldShow) {
        visibleCount += 1;
        if (handle) seenHandles.add(handle);
      }
      desired.set(item, shouldShow);
    });

    const membershipChanged = items.some((item) => item.hidden !== !desired.get(item));
    if (!membershipChanged) return;

    const existingFlickity = recommendationFlickity(list);
    if (existingFlickity) existingFlickity.destroy();

    // destroy() restores Flickity-owned cells to the source list. Hidden fallback
    // candidates were already direct children, so at this point every candidate is
    // once again in one flat list. Apply the already-computed membership once.
    items.forEach((item) => {
      item.hidden = !desired.get(item);
    });

    if (existingFlickity) initializeRecommendationFlickity(list);
  };

  const syncBandwareRecommendationScopes = (detail = null) => {
    const params = new URL(window.location.href).searchParams;
    const centralized = detail?.context || detail || window.BrilintonProductContext?.get?.() || {};
    const wear = normalize(centralized.wearWith || centralized.wear || params.get('wear'));
    const setMode = normalize(centralized.setMode || params.get('set') || 'complete');
    const modelSlug = centralized.royalPopModel || centralized.royalModel || centralized.modelSlug || params.get('model') || '';
    const royalComplete = wear === 'royal-pop' && !['only', 'bandware-only', 'bandware'].includes(setMode);

    document.querySelectorAll('[data-bandware-recommendations-scope]').forEach((root) => {
      syncRecommendationDeviceVisibility(root, wear);
      if (!royalComplete) {
        root.removeAttribute('data-royal-pop-collection-scope');
        root.removeAttribute('data-royal-pop-recommendations-scope');
        delete root.dataset.activeRoyalModel;
        clearScopedCollection(root);
        return;
      }
      root.setAttribute('data-royal-pop-collection-scope', '');
      root.setAttribute('data-royal-pop-recommendations-scope', '');
      root.dataset.activeRoyalModel = modelSlug;
      bindScopedCollection(root);
      applyScopedCollection(root, modelSlug);
    });
  };

  const bindScopedCollection = (root) => {
    if (!root) return;
    if (root.dataset.royalPopSharedBound !== 'true') {
      root.dataset.royalPopSharedBound = 'true';
      root.querySelectorAll('[data-royal-pop-model-choice]').forEach((choice) => {
        choice.addEventListener('click', () => {
          const slug = choice.dataset.modelSlug || '';
          const destination = root.dataset.royalPopNavigateTo;
          if (destination) {
            const url = new URL(destination, window.location.origin);
            if (slug) url.searchParams.set('model', slug);
            window.location.assign(`${url.pathname}${url.search}${url.hash}`);
            return;
          }
          applyScopedCollection(root, slug);
          window.BrilintonDeviceContext?.rememberRoyalPop(slug, 'shared-collection-card-system');
          document.dispatchEvent(new CustomEvent('royal-pop:model-change', {
            detail: { modelSlug: slug, source: 'shared-collection-card-system' }
          }));
        });
      });
    }
    applyScopedCollection(root);
  };

  /* PDP: preserve the original media and add a sibling overlay to each media item. */
  const ensurePdpOverlay = (mediaItem, url) => {
    if (!mediaItem) return;
    let overlay = mediaItem.querySelector(':scope > .royal-pop-pdp-gallery__overlay');
    if (!url) {
      overlay?.remove();
      mediaItem.classList.remove('royal-pop-pdp-gallery--active');
      return;
    }
    mediaItem.classList.add('royal-pop-pdp-gallery--active');
    if (!overlay) {
      overlay = document.createElement('img');
      overlay.className = 'royal-pop-pdp-gallery__overlay';
      overlay.alt = '';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.decoding = 'async';
      overlay.loading = 'eager';
      mediaItem.appendChild(overlay);
    }
    if (overlay.getAttribute('src') !== url) overlay.setAttribute('src', url);
  };

  const applyPdp = (root, model) => {
    if (!root || !model) return;
    const productInfo = root.closest('product-info');
    const mediaGallery = productInfo?.querySelector('media-gallery') || document.querySelector('media-gallery');
    const productModal = document.querySelector(`#ProductModal-${productInfo?.dataset?.section || ''}`)
      || document.querySelector('product-modal');
    const gallery = !isBase(model) && Array.isArray(model.gallery) ? model.gallery : [];
    const alternateGallery = parseJsonNode(
      productInfo?.querySelector('[data-royal-pop-pdp-3-gallery]')
      || document.querySelector('[data-royal-pop-pdp-3-gallery]')
    );
    const useThreeClock = isThreeClock(model) && alternateGallery.length > 0;
    const galleryManaged = window.BrilintonProductGallery?.beginContentUpdate?.(mediaGallery, {
      reason: 'royal-pop-model-context',
    }) === true;

    const composeItem = (item, index) => {
      const baseImage = item?.querySelector?.('img:not(.royal-pop-pdp-gallery__overlay)');
      setImageBase(baseImage, useThreeClock ? (alternateGallery[index] || '') : '');
      ensurePdpOverlay(item, gallery[index] || '');
    };

    try {
      mediaGallery?.querySelectorAll('.product__media-item').forEach(composeItem);
      productModal?.querySelectorAll('.product-media-modal__content > *').forEach(composeItem);
    } finally {
      if (galleryManaged) {
        window.BrilintonProductGallery.endContentUpdate(mediaGallery, {
          reason: 'royal-pop-model-context',
          activeMediaId: mediaGallery?.querySelector('.product__media-item.is-active:not([hidden])')?.dataset?.mediaId,
          resetPosition: false,
          contentChanged: true,
        });
      }
    }

    root.querySelectorAll('[data-royal-pop-model-choice]').forEach((choice) => {
      const selected = normalize(choice.dataset.modelSlug) === normalize(model.slug);
      choice.classList.toggle('is-selected', selected);
      choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    const label = root.querySelector('[data-royal-pop-selected-label]');
    if (label) label.textContent = model.name || 'Royal Pop';
    syncRoyalPopLinks(model.slug || null);
    document.dispatchEvent(new CustomEvent('royal-pop:model-applied', {
      detail: { modelSlug: model.slug, galleryManaged }
    }));
  };

  const initPdpSelector = (root) => {
    if (!root) return;
    const models = parseModels(root.closest('product-info') || document);
    if (!models.length) return;
    const details = root.querySelector('[data-royal-pop-model-details]');
    const selectedLabel = root.querySelector('[data-royal-pop-selected-label]');
    let selectedModel = findModel(models, modelContext()) || models.find(isBase) || models[0];
    applyPdp(root, selectedModel);

    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    if (details && details.dataset.royalPopRailDiscoveryBound !== 'true') {
      details.dataset.royalPopRailDiscoveryBound = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open || !window.matchMedia?.('(max-width: 749px)').matches) return;
        const rail = root.querySelector('.royal-pop-model-selector__slider');
        const selected = rail?.querySelector('.product-option-card.is-selected, .product-option-card[aria-pressed="true"]');
        if (!rail || !selected) return;
        requestAnimationFrame(() => {
          const maxLeft = Math.max(0, rail.scrollWidth - rail.clientWidth);
          const idealLeft = selected.offsetLeft - Math.max(0, (rail.clientWidth - selected.offsetWidth) / 2);
          rail.scrollTo({ left: Math.max(0, Math.min(maxLeft, idealLeft)), behavior: 'auto' });
        });
      });
    }
    root.querySelectorAll('[data-royal-pop-model-choice]').forEach((choice) => {
      const hoveredName = choice.dataset.modelName || '';
      const preview = () => { if (selectedLabel && hoveredName) selectedLabel.textContent = hoveredName; };
      const restore = () => { if (selectedLabel) selectedLabel.textContent = selectedModel?.name || 'Royal Pop'; };
      choice.addEventListener('mouseenter', preview);
      choice.addEventListener('focus', preview);
      choice.addEventListener('mouseleave', restore);
      choice.addEventListener('blur', restore);
      choice.addEventListener('click', () => {
        const model = findModel(models, choice.dataset.modelSlug) || models[Number.parseInt(choice.dataset.modelIndex || '0', 10)];
        if (!model) return;
        selectedModel = model;
        window.BrilintonDeviceContext?.rememberRoyalPop(model.slug || model.name, 'pdp-selector');
        setUrlModel(model);
        applyPdp(root, model);
        document.dispatchEvent(new CustomEvent('royal-pop:model-change', {
          detail: { modelSlug: model.slug, source: 'pdp-selector' }
        }));
        if (details) details.open = false;
      });
    });
  };

  const initColorHover = (scope = document) => {
    scope.querySelectorAll('[data-product-options-stack]').forEach((stack) => {
      if (stack.dataset.colorHoverReady === 'true') return;
      stack.dataset.colorHoverReady = 'true';
      const group = stack.querySelector('[data-product-option-group="color"]');
      const label = group?.querySelector('.selected-value');
      const active = group?.querySelector('#swatches .swatch.active');
      const selectedName = () => active?.dataset.color?.split(' | ')[0]?.trim() || label?.textContent?.trim() || '';
      group?.querySelectorAll('#swatches .swatch').forEach((card) => {
        const name = card.dataset.color?.split(' | ')[0]?.trim() || '';
        const preview = () => { if (label && name) label.textContent = name; };
        const restore = () => { if (label) label.textContent = selectedName(); };
        card.addEventListener('mouseenter', preview);
        card.addEventListener('focus', preview);
        card.addEventListener('mouseleave', restore);
        card.addEventListener('blur', restore);
      });
    });
  };

  const init = () => {
    applyCollection();
    syncBandwareRecommendationScopes();
    document.querySelectorAll('[data-royal-pop-collection-scope]').forEach(bindScopedCollection);
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(initPdpSelector);
    initColorHover();
  };

  document.addEventListener('royal-pop:model-change', (event) => {
    if (!Object.prototype.hasOwnProperty.call(event.detail || {}, 'modelSlug')) return;
    const slug = event.detail.modelSlug || null;
    applyCollection(slug);
    document.querySelectorAll('[data-royal-pop-collection-scope]').forEach((root) => {
      if (event.detail?.source === 'shared-collection-card-system' && normalize(root.dataset.activeRoyalModel) === normalize(slug)) return;
      applyScopedCollection(root, slug);
    });
    document.querySelectorAll(PRODUCT_SELECTOR).forEach((root) => {
      const alreadyApplied = normalize(
        root.querySelector('[data-royal-pop-model-choice].is-selected')?.dataset?.modelSlug
      ) === normalize(slug);
      if (event.detail?.source === 'pdp-selector' && alreadyApplied) return;

      const models = parseModels(root.closest('product-info') || document);
      const model = findModel(models, slug);
      if (model) applyPdp(root, model);
    });
  });
  document.addEventListener('brilinton:product-context-change', (event) => {
    syncBandwareRecommendationScopes(event.detail || {});
  });
  document.addEventListener('product-recommendations:loaded', (event) => {
    if (!event.target?.matches?.('[data-bandware-recommendations-scope]')) return;
    syncBandwareRecommendationScopes();
  });
  document.addEventListener('brilinton:product-gallery:dom-updated', (event) => {
    const scope = event.target?.closest?.('product-info') || event.target || document;
    scope.querySelectorAll?.(PRODUCT_SELECTOR).forEach((root) => {
      const models = parseModels(root.closest('product-info') || scope);
      const selectedSlug = root.querySelector('[data-royal-pop-model-choice].is-selected')?.dataset?.modelSlug
        || modelContext();
      const model = findModel(models, selectedSlug) || models.find(isBase) || models[0];
      if (model) applyPdp(root, model);
    });
  });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('popstate', () => { activeCollectionSlug = modelContext(); init(); });
  window.addEventListener('resize', () => requestAnimationFrame(() => applyCollection(activeCollectionSlug)));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  if (!window.__royalPopGalleryObserverReady) {
    window.__royalPopGalleryObserverReady = true;
    let queued = false;
    const observedRoots = new WeakSet();
    const discoveryObserver = new MutationObserver((mutations) => {
      const changed = mutations.some((mutation) => {
        // Collection/card discovery only. PDP gallery replacement has the
        // explicit `brilinton:product-gallery:dom-updated` lifecycle above, and
        // Related Products has its own recommendation/context lifecycle events.
        // Never treat product-gallery or Flickity DOM movement as card discovery.
        if (mutation.target?.closest?.('.related-products-slider')) return false;
        const targetSlider = mutation.target?.closest?.('.card-product__slider');
        const nativeMediaChanged = [...mutation.addedNodes, ...mutation.removedNodes].some((node) =>
          node.nodeType === 1 && (
            node.matches?.('.product-card-wrapper, #product-grid, .card-product__slider > img') ||
            node.querySelector?.('.product-card-wrapper, .card-product__slider > img') ||
            node.classList?.contains('royal-pop-card-slide-overlay')
          )
        );
        return Boolean(targetSlider && nativeMediaChanged) || Array.from(mutation.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches?.('.product-card-wrapper, #product-grid') || node.querySelector?.('.product-card-wrapper'))
        );
      });
      if (!changed || queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        applyCollection(activeCollectionSlug);
        syncBandwareRecommendationScopes();
        document.querySelectorAll('[data-royal-pop-collection-scope]').forEach(bindScopedCollection);
        initColorHover();
      });
    });

    const observeDiscoveryRoots = (scope = document) => {
      const selector = '#product-grid, [data-royal-pop-collection-scope], [data-royal-pop-landing]';
      const roots = [];
      if (scope?.matches?.(selector)) roots.push(scope);
      scope?.querySelectorAll?.(selector).forEach((root) => roots.push(root));
      roots.forEach((root) => {
        if (observedRoots.has(root)) return;
        observedRoots.add(root);
        discoveryObserver.observe(root, { childList: true, subtree: true });
      });
    };

    observeDiscoveryRoots(document);
    document.addEventListener('shopify:section:load', (event) => {
      observeDiscoveryRoots(event.target || document);
    });
  }
})();